import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MessagePanel from '../MessagePanel';
import { Footer } from '../footer';

import './PublicPageTemplate.scss';

const PublicPageTemplate = props => {
    const { className, children, header } = props;
    const classes = classNames({
        'common-public-page-template': true,
        [className]: className,
    });
    return (
        <>
            <div className={classes} role="main">
                <header className="public-page-header">{header}</header>
                <div className="page-content">{children}</div>
                <div>&nbsp;</div>
                <Footer />
            </div>
            <MessagePanel />
        </>
    );
};

PublicPageTemplate.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    header: PropTypes.node,
};

PublicPageTemplate.defaultProps = {
    className: '',
    header: ' ',
};

export default PublicPageTemplate;
